<template lang="">
    <div id="content">
      <div class="global_area">
        <div class="path"><a href="#none">Home</a> &gt; <a href="#none">캠페인 관리</a> &gt; <strong>캠페인 리스트</strong></div>
        <h2 class="h_sub">캠페인 등록 <span class="fs_regular">[보기&amp;수정]</span></h2>
      </div>
  
      <CampaignManageCreateForm/>
    </div>
  </template>
  
  <script>
  import CampaignManageCreateForm from '@/components/admin/product/CampaignManageCreateForm.vue';
  
  export default {
    components: {
        CampaignManageCreateForm
    }
      
  }
  </script>
  <style lang="">
      
  </style>